<template>
    <div class="upcoming-container">
        <v-expansion-panel dark>
            <v-expansion-panel-content class="grey darken-2" v-model="ueIndex" v-on:click.native="getUpcomingEventsToggle(ueIndex)">
                <div slot="header" class="tournament-title upcoming">
                    Upcoming Events
                </div>
                <v-card>
                    <!--<v-card-title>
                        <v-text-field class="upcoming-event" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>-->
                </v-card>
                <v-data-table v-if="loaded" :headers="headers" :search="search"
                              :items="upcomingEvent">
                    <template v-if="loaded" v-slot:items="props">

                        <td>{{new Date(props.item.startTime) | date }}</td>
                        <td>{{ props.item.tournamentName }}</td>
                        <td>{{ props.item.eventName }}</td>

                    </template>
                </v-data-table>

            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import upcomingEventsApi from '../api/upcomingEvents'
    import { HubConnection } from "@aspnet/signalr";

    export default {
        name: 'UpcomingEvents',
        data() {
            return {
                loaded: false,
                upcomingEvent: null,
                ueIndex: [[true], [false], [true], [false], [true]],
                currentUpcomingSport: [],
                search: '',
                headers: [
                    {
                        text: 'Time',
                        align: 'start',
                        sortable: true,
                        value: 'startTime',
                    },
                    { text: 'Tournament', value: 'tournamentName' },
                    { text: 'Event Name', value: 'eventName' }
                ],

            }
        },
        props: {
            sport: String,
            eventName: String,
            startTime: String,
            connection: HubConnection,
        },
        watch: {
            sport: function (newSport, oldSport) {
                if (newSport !== oldSport) {
                    for (var i = 0; i < this.currentUpcomingSport.length; i++) {
                        this.connection.invoke("UnSubscribe", this.currentUpcomingSport[i] + "upcomingEvents");
                        this.currentUpcomingSport.pop();
                    }
                    if (this.ueIndex === true) {
                        this.connection.invoke("Subscribe", this.sport + "upcomingEvents");
                    }
                    this.getUpcomingEvents(newSport);
                    if (this.connection) {
                        this.connection.on(this.sport + "ua-rcv", (value) => {
                            if (value !== null) {
                                this.addUpcomingEvent(JSON.parse(value));
                            }
                        });
                        this.connection.on(this.sport + "ur-rcv", (value) => {
                            if (value !== null) {
                                this.removeUpcomingEvent(JSON.parse(value));
                            }
                        });
                    }
                }
            },
            ueIndex: function () { }
        },
        methods: {
            getTime(date) {
                //var hours = date.getHours();
                //var mins = date.getMinutes();
                //if (mins <= 9)
                //    mins = '0' + mins
                //return hours + ':' + mins
                return date

            },
            getUpcomingEvents(sport) {
                upcomingEventsApi.getUpcomingEvents(sport)
                    .then(data => {
                        this.upcomingEvent = data.responseObject;
                        this.loaded = true
                    })
            },
            addUpcomingEvent(newEvent) {
                var found = false
                for (let event in this.upcomingEvent) {
                    if (this.upcomingEvent[event].fixtureID == newEvent.FixtureID) {
                        found = true;
                    }
                }
                if (!found) {
                    this.upcomingEvent.push(newEvent);
                }
            },
            removeUpcomingEvent(removeId) {
                for (let eventIndex in this.upcomingEvent) {
                    if (this.upcomingEvent[eventIndex].fixtureID === removeId.fixtureID) {
                        this.upcomingEvent.splice(eventIndex, 1);
                    }
                }

            },
            getUpcomingEventsToggle(ueIndex) {
                if (ueIndex) {
                    this.connection.invoke("Subscribe", this.sport + "upcomingEvents");
                    this.currentUpcomingSport.push(this.sport);
                } else {
                    this.connection.invoke("UnSubscribe", this.sport + "upcomingEvents");
                }
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .v-datatable__actions__select {
        display: none !important;
    }

    .odd {
        color: gold;
    }

    .bold {
        font-weight: 700;
        padding-right: 10px;
    }

    table {
        width: 100%;
        color: #FFFFFF;
        overflow-wrap: break-word;
    }

    th {
        color: #fff;
        border-bottom: 2px solid #696969;
    }

    th, td {
        text-align: left;
        padding: 4px;
        font-size: 14px !important;
        padding-bottom: 10px !important;
        font-weight: 300;
    }

    .tournament-title.upcoming {
        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 10px;
        background-color: #020381;
        border-color: #020381 !important;
    }

    .grey.darken-2 {
        background-color: #020381 !important;
    }

    @media only screen and (max-width: 768px), (min-device-width: 768px) and (max-device-width: 1024px) {
        th, td {
            text-align: left;
            /*padding: 4px;*/
            font-size: 11px !important;
            font-weight: 300;
        }

        .upcoming-container {
            /*overflow: auto;
            height: 400px;*/
        }
    }
</style>
